import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Project, ProjectControllerService} from "../../../api";
import {Router} from "@angular/router";
import {catchError, forkJoin, Observable, of} from "rxjs";
import {BicToastService} from '@buildinginformationcloud/bic-ui-components';
import {serverErrorMessage} from '../../my-checks/shared/server-error-message';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {MatChipListbox, MatChipOption} from "@angular/material/chips";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton} from "@angular/material/button";
import {HoldableDirective} from "../../../directives/holdable.directive";


@Component({
  selector: 'app-deleteDialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatChipListbox,
    MatTooltip,
    MatButton,
    MatDialogClose,
    HoldableDirective,
    MatChipOption
  ]
})
export class DeleteDialogComponent implements OnInit {
  data = inject<{
    projects?: [
      Project
    ];
  }>(MAT_DIALOG_DATA);
  private router = inject(Router);
  private dialogRef = inject<MatDialogRef<DeleteDialogComponent>>(MatDialogRef);
  private projectControllerService = inject(ProjectControllerService);
  private toastService = inject(BicToastService);


  ngOnInit(): void {
  }

  holdHandler(e: any) {
    if (e === 3000) {

      // Je Projekt einzeln abfangen: ein abgelehntes Projekt (z. B. Eigentümer geteilter Prüfläufe)
      // soll die anderen nicht abbrechen, und der Grund muss beim Nutzer ankommen.
      let observables: Observable<unknown>[] = [];

      if(this.data.projects) {
        this.data.projects.forEach(project => observables.push(
          this.projectControllerService.deleteProject(project.id!).pipe(
            catchError(err => {
              this.toastService.error(serverErrorMessage(err,
                `Das Projekt „${project.name}“ konnte nicht gelöscht werden.`));
              return of(null);
            }),
          )))
      }

      forkJoin(observables).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }

}
